import { render, staticRenderFns } from "./event.vue?vue&type=template&id=828bc9be&scoped=true&"
import script from "./event.vue?vue&type=script&lang=js&"
export * from "./event.vue?vue&type=script&lang=js&"
import style0 from "./event.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./event.vue?vue&type=style&index=1&id=828bc9be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828bc9be",
  null
  
)

export default component.exports